import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-301467a5"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]


export default /*#__PURE__*/_defineComponent({
  __name: 'display-html',
  props: {
    htmlContent: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "html-content",
    innerHTML: _ctx.htmlContent
  }, null, 8, _hoisted_1))
}
}

})